/* eslint-disable */
import {
  getPartners,
  getCurrentPartner,
  updatePartner,
  getPartnerCooperationType,
  getPartnerPersonalAccounts,
  createPartnerStorageItem,
  updatePartnerStorageItem,
  getPartnerStorages,
  getResponsibleUsers,
  getPartnerRatingMatrix,
  getPartnerExport,
  getPartnerUserList,
  createPartnerUserItem,
  updatePartnerUserItem,
  deletePartnerUserItem,
  getPartnerStatistics,
} from '@/methods/partner';
import { ElNotification } from 'element-plus';
import store from '@/store';
import router from '@/router';
import {formatDate, getErrorMessage} from '@/compositions/helpers/helpers';
import {getReturnExport} from "@/methods/return";

// Список ЛК партнёра перезапрашивается при каждой смене partnerId (в т.ч. при первичной
// загрузке брони на редактировании — см. createNewBookingItemForm.js), запросы могут
// отвечать в произвольном порядке. Без этой защиты устаревший ответ может прийти позже
// актуального и затереть его — поле "Наименование ЛК" визуально пустеет/не показывается.
// Тот же приём уже используется для driversLatestKey в Driver.js.
let personalAccountsLatestKey = null;

const state = {
  list: [],
  fullData: [],
  currentPartner: {},
  ratingMatrix: {},
  partnerStorages: [],
  partnerCooperationType: [],
  // Список ЛК партнёра — договоры MPL comission (LOGNET-1118)
  partnerPersonalAccounts: [],
  isLoading: false,
  createdStorage: null,
  filters: [],
  responsibleUsers: [],
  partnerUserList: {},
  partnerStatistics: {},
  dataIsUpdated: {
    userList: false,
  },
};

const getters = {
  getPartnerList(state) {
    return state.list;
  },
  getPartnersFullData(state) {
    return state.fullData;
  },
  getCurrentPartner(state) {
    return state.currentPartner;
  },
  getPartnerCooperationType(state) {
    return state.partnerCooperationType;
  },
  getPartnerPersonalAccounts(state) {
    return state.partnerPersonalAccounts;
  },
  getPartnerStorages(state) {
    return state.partnerStorages;
  },
  getFilters(state) {
    return state.filters;
  },
  getResponsibleUsers(state) {
    return state.responsibleUsers;
  },
  getPartnerStatistics(state) {
    return state.partnerStatistics;
  },
};

const mutations = {
  UPDATE_PARTNER_LIST(state, data) {
    state.list = data;
  },
  UPDATE_PARTNERS(state, data) {
    state.fullData = data;
  },
  UPDATE_CURRENT_PARTNER(state, data) {
    state.currentPartner = data;
  },
  UPDATE_PARTNER_COOPERATION_TYPE(state, data) {
    state.partnerCooperationType = data;
  },
  UPDATE_PARTNER_PERSONAL_ACCOUNTS(state, data) {
    state.partnerPersonalAccounts = data;
  },
  UPDATE_IS_LOADING(state, data) {
    state.isLoading = data;
  },
  UPDATE_NEW_STORAGE(state, data) {
    state.createdStorage = data;
  },
  UPDATE_PARTNER_STORAGES(state, data) {
    state.partnerStorages = data;
  },
  UPDATE_PARTNER_RATING_MATRIX(state, data) {
    state.ratingMatrix = data;
  },
  UPDATE_FILTERS(state, data) {
    state.filters = data;
  },
  UPDATE_RESPONSIBLE_USERS(state, data) {
    state.responsibleUsers = data;
  },
  UPDATE_PARTNER_USER_LIST(state, data) {
    state.partnerUserList = data;
  },
  PARTNER_USER_LIST_DATA_IS_UPDATED(state, data) {
    state.dataIsUpdated.userList = data;
  },
  UPDATE_PARTNER_STATISTICS(state, data) {
    state.partnerStatistics = data;
  },
};

const actions = {
  getPartnerList({ commit, state }, params) {
    getPartners(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          commit(
            'UPDATE_PARTNER_LIST',
            response.data.data.data.sort((a, b) => a.name - b.name)
          );
          commit('privilege/UPDATE_PARTNER_PRIVILEGE', response.data.privilege, { root: true });
        }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          store.commit('auth/UPDATE_CONTENT_AVAILABILITY', false);

          if (!router.currentRoute.value.query?.forbidden) {
            router
              .replace({
                name: router.currentRoute.value.name,
                query: { ...router.currentRoute.value.query, forbidden: true },
              })
              .then(() => {
                location.reload();
              });
          }
        }
      });
  },

  getPartners({ commit, state }, params) {
    getPartners(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          commit('UPDATE_PARTNERS', response.data.data);
          commit('privilege/UPDATE_PARTNER_PRIVILEGE', response.data.privilege, { root: true });
        }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          store.commit('auth/UPDATE_CONTENT_AVAILABILITY', false);

          if (!router.currentRoute.value.query?.forbidden) {
            router
              .replace({
                name: router.currentRoute.value.name,
                query: { ...router.currentRoute.value.query, forbidden: true },
              })
              .then(() => {
                location.reload();
              });
          }
        }
      });
  },
  getResponsibleUsers({ commit, state }, params) {
    getResponsibleUsers(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          commit('UPDATE_RESPONSIBLE_USERS', response.data.data);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 10000,
        });
      });
  },
  getCurrentPartner({ commit, state }, params) {
    getCurrentPartner(params).then((response) => {
      if ('success' in response.data && response.data.success) {
        commit('UPDATE_CURRENT_PARTNER', response.data.data);
      }
    });
  },
  getPartnerStatistics({ commit, state }, params) {
    getPartnerStatistics(params)
      .then((res) => {
        if ('success' in res.data && res.data.success) {
          commit('UPDATE_PARTNER_STATISTICS', res.data.data);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 10000,
        });
      });
  },
  getPartnerStorages({ commit, state }, params) {
    getPartnerStorages(params).then((response) => {
      if ('success' in response.data && response.data.success) {
        commit('UPDATE_PARTNER_STORAGES', response.data.data);
      }
    });
  },
  getPartnerCooperationType({ commit, state }, params) {
    getPartnerCooperationType(params).then((response) => {
      if ('success' in response.data && response.data.success) {
        commit('UPDATE_PARTNER_COOPERATION_TYPE', response.data.data);
      }
    });
  },
  getPartnerPersonalAccounts({ commit, state }, params) {
    const partnerId = Number(params) || null;
    personalAccountsLatestKey = partnerId;

    if (!partnerId) {
      commit('UPDATE_PARTNER_PERSONAL_ACCOUNTS', []);

      return Promise.resolve();
    }

    return getPartnerPersonalAccounts(partnerId).then((response) => {
      if (partnerId !== personalAccountsLatestKey) return;

      if ('success' in response.data && response.data.success) {
        commit('UPDATE_PARTNER_PERSONAL_ACCOUNTS', response.data.data);
      }
    });
  },
  getPartnerRatingMatrix({ commit, state }, params) {
    getPartnerRatingMatrix(params).then((response) => {
      if ('success' in response.data && response.data.success) {
        commit('UPDATE_PARTNER_RATING_MATRIX', response.data.data);
      }
    });
  },
  createPartnerStorageItem({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      createPartnerStorageItem(params)
        .then((response) => {
          if ('success' in response.data && response.data.success) {
            commit('UPDATE_NEW_STORAGE', response.data.data.id);
            resolve(response.data.data.id);
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          ElNotification.error({
            dangerouslyUseHTMLString: true,
            message: getErrorMessage(error?.response?.data),
            duration: 10000,
          });

          commit('booking/UPDATE_BOOKING_IS_LOADING', false, { root: true });
          reject(error);
        });
    });
  },
  updatePartnerStorageItem({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      updatePartnerStorageItem(params)
        .then((response) => {
          if ('success' in response.data && response.data.success) {
            ElNotification.success({
              message: response.data.message,
              duration: 2000,
            });
            resolve(response.data.data.id);
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          ElNotification.error({
            dangerouslyUseHTMLString: true,
            message: getErrorMessage(error?.response?.data),
            duration: 10000,
          });
          reject(error);
        });
    });
  },
  updatePartner({ commit, state }, params) {
    commit('UPDATE_IS_LOADING', true);
    updatePartner(params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });
        }
        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 10000,
        });
        commit('UPDATE_IS_LOADING', false);
      });
  },

  async getPartnerExport({ commit, state }, params) {
    try {
      const response = await getPartnerExport(params);

      const downloadLink = document.createElement('a');
      const blob = new Blob(['\ufeff', response.data]);
      const correctName = response.headers['Content-Disposition']?.split(' ')[1]?.split('=')[1];

      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = correctName ? `${correctName.slice(1, -1)}-${formatDate(new Date())}.csv` : `partner-${formatDate(new Date())}.csv`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      return response;
    } catch (error) {
      throw error;
    }
  },

  getPartnerUserList({ commit, state }, { partnerId, params }) {
    getPartnerUserList(partnerId, params)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          commit('UPDATE_PARTNER_USER_LIST', response.data.data);
          commit('privilege/UPDATE_MANAGE_PARTNER_USER_PRIVILEGE', response.data.privilege, { root: true });
        }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          store.commit('auth/UPDATE_CONTENT_AVAILABILITY', false);

          if (!router.currentRoute.value.query?.forbidden) {
            router
              .replace({
                name: router.currentRoute.value.name,
                query: { ...router.currentRoute.value.query, forbidden: true },
              })
              .then(() => {
                location.reload();
              });
          }
        }
      });
  },

  createPartnerUserItem({ commit, state }, data) {
    createPartnerUserItem(data)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('PARTNER_USER_LIST_DATA_IS_UPDATED', true);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 10000,
        });
      });
  },

  updatePartnerUserItem({ commit, state }, data) {
    updatePartnerUserItem(data)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('PARTNER_USER_LIST_DATA_IS_UPDATED', true);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 10000,
        });
      });
  },

  deletePartnerUserItem({ commit, dispatch, state }, data) {
    deletePartnerUserItem(data)
      .then((response) => {
        if ('success' in response.data && response.data.success) {
          ElNotification.success({
            message: response.data.message,
            duration: 2000,
          });

          commit('PARTNER_USER_LIST_DATA_IS_UPDATED', true);
        }
      })
      .catch((error) => {
        ElNotification.error({
          dangerouslyUseHTMLString: true,
          message: getErrorMessage(error?.response?.data),
          duration: 10000,
        });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
